import React from 'react';
import { Helmet } from 'react-helmet-async';

const ZoomInfo = () => {
    return (
        <Helmet>
            <script defer>
                {`
                window[(function(_VVs, _kw) {
                    var _Fd = '';
                    for (var _Eb = 0; _Eb < _VVs.length; _Eb++) {
                        var _RF = _VVs[_Eb].charCodeAt();
                        _RF -= _kw;
                        _RF += 61;
                        _RF %= 94;
                        _RF += 33;
                        _Fd += String.fromCharCode(_RF);
                    }
                    return _Fd;
                })(atob('a1phJSJ7dnQnXHYs'), 17)] = '7ff89a944a1679923173';

                var zi = document.createElement('script');
                zi.type = 'text/javascript';
                zi.async = true;
                zi.src = (function(_Rxi, _Yx) {
                    var _EC = '';
                    for (var _C7 = 0; _C7 < _Rxi.length; _C7++) {
                        var _jY = _Rxi[_C7].charCodeAt();
                        _jY -= _Yx;
                        _jY += 61;
                        _jY %= 94;
                        _jY += 33;
                        _EC += String.fromCharCode(_jY);
                    }
                    return _EC;
                })(atob('Kzc3MzZbUFAtNk89LE42JjUsMzc2TyYyMFA9LE43JCpPLTY='), 33);

                document.readyState === 'complete'
                    ? document.body.appendChild(zi)
                    : window.addEventListener('load', function() {
                        document.body.appendChild(zi);
                    });
                `}
            </script>
        </Helmet>
    );
};

export default ZoomInfo;